import { initializeEnovaForm } from './disassembly/form';
import { addAlert } from './alerts';

async function updatePhotoUrls(componentId) {
    const photosModal = document.getElementById('photosWindow');
    if (!photosModal) return;

    const fileGallery = photosModal.querySelector('.file-gallery');
    if (!fileGallery || !fileGallery.galleryInstance) return;

    const getUrl = fileGallery.dataset.getUrl;
    const addUrl = fileGallery.dataset.addUrl;
    const removeUrl = fileGallery.dataset.removeUrl;

    const idRegex = /\/\d+\//;
    let urlsUpdated = false;

    if (getUrl) {
        const newGetUrl = getUrl.replace(idRegex, `/${componentId}/`);
        if (newGetUrl !== getUrl) {
            fileGallery.dataset.getUrl = newGetUrl;
            urlsUpdated = true;
        }
    }
    if (addUrl) {
        const newAddUrl = addUrl.replace(idRegex, `/${componentId}/`);
        if (newAddUrl !== addUrl) {
            fileGallery.dataset.addUrl = newAddUrl;
            urlsUpdated = true;
        }
    }
    if (removeUrl) {
        const newRemoveUrl = removeUrl.replace(idRegex, `/${componentId}/`);
        if (newRemoveUrl !== removeUrl) {
            fileGallery.dataset.removeUrl = newRemoveUrl;
            urlsUpdated = true;
        }
    }

    if (urlsUpdated) {
        await fileGallery.galleryInstance.loadData();
    }
}

export function initializeCatalogModule() {
    const container = document.querySelector('.catalog-component-container');
    if (!container) return;

    const sidePanel = container.querySelector('.side-panel');
    const formContainer = container.querySelector('#enova-form-container');
    const newComponentBtn = container.querySelector('#newComponentBtn');
    const formModeText = container.querySelector('#form-mode-text');
    const formPlaceholder = container.querySelector('.enova-form.placeholder');
    const partsContainer = sidePanel.querySelector('.disassembly-parts');
    const photosButton = document.querySelector(
        'button[data-window="photosWindow"]',
    );

    const getFormUrl = container.dataset.getFormUrl;
    const disassemblyId = container.dataset.disassemblyId;

    let currentSelectedPartElement = null;

    if (photosButton) {
        photosButton.disabled = true;
    }

    // --- Function to load and display the form ---
    async function loadForm(params = {}) {
        try {
            const url = new URL(getFormUrl, window.location.origin);
            Object.keys(params).forEach((key) =>
                url.searchParams.append(key, params[key]),
            );

            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();

            hidePlaceholder();
            formContainer.innerHTML = data.form_html;
            const newForm = formContainer.querySelector('form.enova-form');

            initializeEnovaForm(newForm, handleSuccessfulSave);

            const isEditing = newForm.querySelector('#id_code').value !== '';
            formModeText.textContent = isEditing
                ? gettext('EDYCJA')
                : gettext('NOWA');
        } catch (error) {
            console.error('Error loading form:', error);
            addAlert('error', gettext('Nie udało się załadować formularza.'));
            showPlaceholder();
        }
    }

    // --- Function to update UI after successful save ---
    function handleSuccessfulSave({ id, enova_data }) {
        if (!currentSelectedPartElement) {
            const componentName =
                enova_data.type || enova_data.group || enova_data.code;
            const newComponentEntry = document.createElement('div');
            const count = partsContainer.children.length;
            newComponentEntry.className =
                'disassembly-part standalone-component';
            newComponentEntry.dataset.enovaId = enova_data.code;
            newComponentEntry.dataset.componentId = id;
            newComponentEntry.innerHTML = `
             <small>
                <span class="counter">${count + 1}</span>
                <span class="status">${gettext('SKATALOGOWANO')}</span>
             </small>
             <div class="part-input">
                <input readonly
                           class="disassembly-checkbox"
                           type="checkbox" checked />
                <span class="part-name">${componentName}</span>
                <div class="right-side">
                    <button type="button" class="part-link select-part">${gettext('EDYTUJ KARTĘ EGZEMPLARZA')}</button>
                </div>
            </div>`;
            partsContainer.appendChild(newComponentEntry);
        } else {
            currentSelectedPartElement.dataset.componentId = id;
            currentSelectedPartElement.dataset.enovaId = enova_data.code;
            currentSelectedPartElement.querySelector(
                '.disassembly-checkbox',
            ).checked = true;
            currentSelectedPartElement.querySelector('.status').innerText =
                gettext('SKATALOGOWANO');
            currentSelectedPartElement.querySelector('.select-part').innerText =
                gettext('EDYTUJ KARTĘ EGZEMPLARZA');
        }
        showPlaceholder();
    }

    // --- Function to visually select a part ---
    function selectPartElement(partElement) {
        if (currentSelectedPartElement) {
            const prevLink =
                currentSelectedPartElement.querySelector('.part-link');
            if (prevLink) prevLink.classList.remove('active');
        }
        sidePanel
            .querySelectorAll('.standalone-component .part-link.active')
            .forEach((el) => el.classList.remove('active'));

        if (partElement) {
            const link = partElement.querySelector('.part-link');
            if (link) link.classList.add('active');
            currentSelectedPartElement = partElement;
            const componentId = partElement.dataset.componentId;
            if (componentId) {
                photosButton.disabled = false;
                updatePhotoUrls(componentId);
            } else {
                photosButton.disabled = true;
            }
        } else {
            currentSelectedPartElement = null;
            photosButton.disabled = true;
        }
    }

    // --- Function to show placeholder ---
    function showPlaceholder() {
        formPlaceholder.classList.remove('hidden');
        const form = formContainer.querySelector('form.enova-form');
        if (form) form.remove();
        selectPartElement(null);
    }

    // --- Function to hide placeholder ---
    function hidePlaceholder() {
        formPlaceholder.classList.add('hidden');
    }
    // --- Event Listeners ---

    // Use event delegation for part links
    sidePanel.addEventListener('click', function (event) {
        const link = event.target.closest('.select-part');
        const standaloneLink = event.target.closest('.select-standalone');

        if (link) {
            event.preventDefault();
            const partElement = link.closest('.disassembly-part');
            const partId = partElement.dataset.partId;
            const enovaId = partElement.dataset.enovaId;

            selectPartElement(partElement);

            if (enovaId) {
                loadForm({ component: enovaId });
            } else {
                loadForm({ disassembly_part: partId });
            }
        } else if (standaloneLink) {
            event.preventDefault();
            const componentElement = standaloneLink.closest(
                '.standalone-component',
            );
            const enovaId = componentElement.dataset.enovaId;

            selectPartElement(componentElement);

            if (enovaId) {
                loadForm({ component: enovaId });
            }
        }
    });

    // Listener for "Add new component" button
    newComponentBtn.addEventListener('click', function () {
        selectPartElement(null);
        loadForm(disassemblyId ? { disassembly: disassemblyId } : {});
    });

    showPlaceholder();
}
